module.exports = __webpack_public_path__ + "static/media/Diancie_gaussian2.ae2f723f.png";